// Case- and accent-insensitive text normalization ("ha noi" matches "Hà Nội").
export const normalizeText = (str) =>
  String(str ?? "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase()
    .trim();

// True when `query` is empty or found in any of `fields`.
export const matchesQuery = (query, ...fields) => {
  const needle = normalizeText(query);
  if (!needle) return true;
  return fields.some((f) => normalizeText(f).includes(needle));
};
